export const PAGE_VSCROLL_LISTENER = '_PAGE_VSCROLL_LISTENER';
export const RESIZE_LISTENER = '_RESIZE_LISTENER';
export const PRINT_MAX_COLS_PER_PAGE = 10;
export const PRINT_COLUMN_WIDTH = 128;
export const PRINT_TABLE_SCALE = 0.68;
export const PRINT_ROW_HEIGHT = 46;
export const PRINT_FIRST_ROW_HEIGHT = 43;
export const PRINT_HEADER_HEIGHT = 61;
export const NAVBAR_HEIGHT_PX = 76;

export const getAdvancedReportClassProperty = (numberOfCols, isPrint) => {
  let cssClasses = [];
  if (numberOfCols === 0) {
    cssClasses = ['min-width'];
  } else if (numberOfCols !== 2) {
    cssClasses = ['min-width', 'content-size'];
  } else {
    cssClasses = ['content-size'];
  }
  if (isPrint) {
    cssClasses.push('is-print');
  }
  return cssClasses.join(' ');
};

export const getMultiSelectButtonClassProperty = (numberOfCols, hasDeleteButton) => {
  if (numberOfCols === 0 || (numberOfCols == 4 && !hasDeleteButton) || numberOfCols > 4) {
    return 'align-right';
  } else {
    return '';
  }
};

export const getStartingYearDropdownButtonClassProperty = (numberOfCols, hasDeleteButton) => {
  if (numberOfCols === 0 || (numberOfCols == 4 && !hasDeleteButton) || numberOfCols > 4) {
    return 'align-right secondary';
  } else {
    return 'secondary';
  }
};

export const computeYearColumnReactProperties = (domElement, isAdviserArea, isExternal) => {
  const defaultReactProperties = {
    className: 'header',
  };
  if (!domElement) {
    return defaultReactProperties;
  }

  const scrollTopPx = ADV.util.getScrollTop(window);
  const offset = ADV.util.getOffset(domElement.parentElement);
  if (scrollTopPx > offset.top - (isAdviserArea ? NAVBAR_HEIGHT_PX : 0)) {
    return {
      className: isAdviserArea
        ? 'header fixed'
        : `header fixed consumer ${isExternal ? 'external' : ''}`,
    };
  } else {
    return defaultReactProperties;
  }
};

export const computeDataColumnReactProperties = (domElement, isAdviserArea, isExternal) => {
  const defaultReactProperties = {
    className: 'header',
  };
  if (!domElement) {
    return defaultReactProperties;
  }

  const scrollTopPx = ADV.util.getScrollTop(window),
    el = domElement,
    offset = ADV.util.getOffset(el.parentElement),
    oldWidth = el.parentElement.offsetWidth;

  if (scrollTopPx > offset.top - (isAdviserArea ? NAVBAR_HEIGHT_PX : 0)) {
    let targetEl = domElement;
    if (targetEl.scroll) targetEl.scroll(el.parentElement.scrollLeft, 0);
    /*IE11*/ else targetEl.scrollLeft = el.parentElement.scrollLeft;
    return {
      className: isAdviserArea
        ? 'header fixed'
        : `header fixed consumer ${isExternal ? 'external' : ''}`,
      style: {
        width: `${oldWidth}px`,
      },
    };
  } else {
    return defaultReactProperties;
  }
};

export const setPageVScrollListener = callback => {
  if (!callback) {
    if (window.hasOwnProperty(PAGE_VSCROLL_LISTENER)) {
      window.removeEventListener('scroll', window[PAGE_VSCROLL_LISTENER], true);
      delete window[PAGE_VSCROLL_LISTENER];
    }
    return;
  }

  if (window.hasOwnProperty(PAGE_VSCROLL_LISTENER)) {
    console.warn(`${PAGE_VSCROLL_LISTENER} already registered, replacing the old listener!`);
    setPageVScrollListener(null);
  }
  window[PAGE_VSCROLL_LISTENER] = callback;
  window.addEventListener('scroll', callback, true);
};

export const setResizeListener = callback => {
  if (!callback) {
    if (window.hasOwnProperty(RESIZE_LISTENER)) {
      window.removeEventListener('resize', window[RESIZE_LISTENER], true);
      delete window[RESIZE_LISTENER];
    }
    return;
  }

  if (window.hasOwnProperty(RESIZE_LISTENER)) {
    console.warn(`${RESIZE_LISTENER} already registered, replacing the old listener!`);
    setResizeListener(null);
  }
  window[RESIZE_LISTENER] = callback;
  window.addEventListener('resize', callback, true);
};

export const getSpanValueReactProperties = (index, numberOfColumns, currentCssClasses) => {
  const cssClasses = currentCssClasses ? currentCssClasses : [];

  if (index === 0) {
    cssClasses.push('first-column');
  }

  if (index === numberOfColumns - 1) {
    cssClasses.push('last-column');
  }
  if (cssClasses.length) {
    return {
      className: cssClasses.join(' '),
    };
  } else {
    return {};
  }
};

export const getTableClassProperties = (hasSpouse, isPrint, currentCssClasses) => {
  const cssClasses = currentCssClasses ? currentCssClasses.split(' ') : [];
  if (hasSpouse) {
    cssClasses.push('has-spouse');
  }

  if (isPrint) {
    cssClasses.push('is-print');
  }

  if (cssClasses.length) {
    return {
      className: cssClasses.join(' '),
    };
  } else {
    return {};
  }
};

export const getTableStyleProperties = (isPrint, rows) => {
  const cssStyle = {};
  if (isPrint) {
    cssStyle['marginBottom'] = `-${(1 - PRINT_TABLE_SCALE) *
      ((rows - 1) * PRINT_ROW_HEIGHT + PRINT_HEADER_HEIGHT + PRINT_FIRST_ROW_HEIGHT)}px`;
  }

  if (cssStyle != {}) {
    return {
      style: cssStyle,
    };
  } else {
    return {};
  }
};

export const getColumnStyleProperties = (isPrint, cols, dataHeaderState) => {
  const cssStyle = {};
  if (dataHeaderState && dataHeaderState.hasOwnProperty('style')) {
    cssStyle['transform'] = dataHeaderState.style.transform;
  }
  if (isPrint) {
    if (cols * 2 <= PRINT_MAX_COLS_PER_PAGE) {
      cssStyle['width'] = `${PRINT_COLUMN_WIDTH * 2}px`;
    } else {
      cssStyle['width'] = `${(PRINT_COLUMN_WIDTH * PRINT_MAX_COLS_PER_PAGE) / cols}px`;
    }
  }
  if (cssStyle != {}) {
    return {
      style: cssStyle,
    };
  } else {
    return {};
  }
};

export const preprocessReceivedReport = (report, data) => {
  let reportColumns = [],
    tableColumns = [],
    numberOfColumns = 0,
    numberOfRows = 0,
    hashTable = {};

  if (report && data) {
    reportColumns.forEach(x => (hashTable[x] = true));
    const new_columns = report.Columns.filter(item => {
      return !hashTable[item];
    });
    reportColumns = reportColumns.concat(new_columns);
    tableColumns = reportColumns.map(() => report.Values.map(() => 0));

    let dataOrder = reportColumns.map((_, i) => i);

    for (let i = 0; i < report.Values.length; i++) {
      const line = report.Values[i];
      for (let j = 0; j < reportColumns.length; j++) {
        tableColumns[j][i] = line[dataOrder[j]];
      }
    }
    numberOfRows = report.Values.length;
    numberOfColumns = tableColumns.length;
  }
  return {
    originalReport: report,
    reportColumns,
    tableColumns,
    numberOfColumns,
    numberOfRows,
  };
};

export const preprocessReceivedData = data => {
  const groups = Object.keys(data.ColumnsByGroup);
  const defaults = Object.keys(data.DefaultReports);
  const ColumnsGroups = {};
  const ColumnsOrder = {};
  const Columns = [];
  let index = 0;

  defaults.forEach(defaultKey => {
    data.DefaultReports[defaultKey].Columns.forEach(column => {
      ColumnsOrder[column] = index;
      index++;
    });
  });

  groups.forEach(group => {
    data.ColumnsByGroup[group].Columns.forEach(column => {
      Columns.push(column);
      ColumnsGroups[column] = group;
      if (!ColumnsOrder.hasOwnProperty(column)) {
        ColumnsOrder[column] = index;
        index++;
      }
    });
  });
  return Object.assign({}, data, {
    ColumnsOrder,
    ColumnsGroups,
    Columns,
  });
};
